module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "title29"
    }
  }), _c('div', {
    staticClass: "title-toc"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_titlePage",
    attrs: {
      "href": "#/e9781429952637_tp01",
      "id": "toctitle26",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Title Page")])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_frontMatter",
    attrs: {
      "href": "#/e9781429952637_fm01",
      "id": "toctitle1"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Preface")])])])]), _c('br'), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429952637_c01",
      "id": "toctitle2"
    }
  }, [_c('span', [_vm._v("CHAPTER 1 - "), _c('em', {
    staticClass: "i"
  }, [_vm._v("“Authors Too Ourselves”")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429952637_c02",
      "id": "toctitle3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("CHAPTER 2 - "), _c('strong', {
    staticClass: "b"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Praise and Pewter")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429952637_c03",
      "id": "toctitle4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("CHAPTER 3 - "), _c('strong', {
    staticClass: "b"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Mouldering in the Grave")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429952637_c04",
      "id": "toctitle5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("CHAPTER 4 - "), _c('strong', {
    staticClass: "b"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("A Vexed Question")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429952637_c05",
      "id": "toctitle6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("CHAPTER 5 - "), _c('strong', {
    staticClass: "b"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Divine Jane")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429952637_c06",
      "id": "toctitle7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("CHAPTER 6 - "), _c('strong', {
    staticClass: "b"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Canon and Canonization")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429952637_c07",
      "id": "toctitle8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("CHAPTER 7 - "), _c('strong', {
    staticClass: "b"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Jane Austen")]), _c('span', {
    staticClass: "imageinline"
  }, [_vm._v("-")])])])]), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_alsoby",
    attrs: {
      "href": "#/e9781429952637_als01",
      "id": "toctitle9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("ALSO BY CLAIRE HARMAN")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_backMatter",
    attrs: {
      "href": "#/e9781429952637_bm01",
      "id": "toctitle10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Abbreviations")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_backMatter",
    attrs: {
      "href": "#/e9781429952637_bm02",
      "id": "toctitle11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Notes")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_backMatter",
    attrs: {
      "href": "#/e9781429952637_bm03",
      "id": "toctitle20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Manuscript Sources")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_backMatter",
    attrs: {
      "href": "#/e9781429952637_bm04",
      "id": "toctitle21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Selected Bibliography")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_acknowPage",
    attrs: {
      "href": "#/e9781429952637_ack01",
      "id": "toctitle22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Acknowledgments")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_index",
    attrs: {
      "href": "#/e9781429952637_ind01",
      "id": "toctitle23",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Index")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_aboutAuthorPage",
    attrs: {
      "href": "#/e9781429952637_ata01",
      "id": "toctitle24",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("About the Author")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_praisePage",
    attrs: {
      "href": "#/e9781429952637_pra01",
      "id": "toctitle25",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("PRAISE FROM THE UNITED KINGDOM FOR")]), _vm._v(" - "), _c('em', {
    staticClass: "i"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Jane’s Fame")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_pubInfo",
    attrs: {
      "href": "#/e9781429952637_cop01",
      "id": "toctitle27",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Copyright Page")])]), _c('br')])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b6a1e33c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781429952637_toc01.vue
// module id = 66
// module chunks = 0